export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Files.json?hash=52adb566e94b931976933244b4561d30";